import { saveGSTR1ToPortal } from '../../../services/gst/portalService'

export const ActionTypes = {
  SAVE_GSTR1_TO_PORTAL: 'SAVE_GSTR1_TO_PORTAL',
}

export const saveGSTR1ToPortalAction = (retPeriod: string, gstr1Json: Record<string, any>) => ({
  type: ActionTypes.SAVE_GSTR1_TO_PORTAL,
  promise: saveGSTR1ToPortal(retPeriod, gstr1Json),
})

export const saveGSTR1ToPortalResetAction = () => ({
  type: `${ActionTypes.SAVE_GSTR1_TO_PORTAL}_RESET`,
})

interface SaveGSTR1State {
  loading: boolean
  success: boolean
  error: string | null
  message: string | null
  errorCode: string | null
}

const initialState: SaveGSTR1State = {
  loading: false,
  success: false,
  error: null,
  message: null,
  errorCode: null,
}

export const saveGSTR1 = (
  state: SaveGSTR1State = initialState,
  action: { type: string; res: any }
): SaveGSTR1State => {
  switch (action.type) {
    case `${ActionTypes.SAVE_GSTR1_TO_PORTAL}_REQUEST`:
      return { ...initialState, loading: true }

    case `${ActionTypes.SAVE_GSTR1_TO_PORTAL}_SUCCESS`:
      return {
        ...state,
        loading: false,
        success: action.res?.success ?? false,
        message: action.res?.message ?? null,
        errorCode: action.res?.success ? null : (action.res?.code ?? action.res?.errorCode ?? null),
      }

    case `${ActionTypes.SAVE_GSTR1_TO_PORTAL}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.res?.message ?? 'Failed to save GSTR1',
        message: action.res?.message ?? 'Failed to save GSTR1',
        errorCode: action.res?.code ?? action.res?.errorCode ?? null,
      }

    case `${ActionTypes.SAVE_GSTR1_TO_PORTAL}_RESET`:
      return { ...initialState }

    default:
      return state
  }
}
